import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from "../common/page-title/index";
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input'
import SecurityQuestionAnswer from '../common/form/user/security-question-answer-input'
import ArrowButton from '../common/button-arrow'
import InlineCKEditor from "../common/editor/inline-editor";
import { loadPageContent } from "../../actions/content";
import { updateSecurityQuestions } from '../../actions/update-security-questions';
import { getQuestions } from '../../actions/about-you'

import './update-security-questions.css'

const PAGE_SLUG_UPDATE_SECURITY_QUESTION = 'update-security-questions';

class UpdateSecurityQuestions extends Component {

  componentWillMount() {
    this.props.dispatch(getQuestions());
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_UPDATE_SECURITY_QUESTION}`));
  }

  updateErrors = (field, value) => {
    this.setState({ [field]: value });
  };

  onSaveClicked = (payload) => {
      this.props.dispatch(actions.submitFields('deep.updateSecQ.user', updateSecurityQuestions('/my-profile', payload)));
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${PAGE_SLUG_UPDATE_SECURITY_QUESTION}`));
  };

  render() {
    return (
      <Form
        model="deep.updateSecQ.user"
        onSubmit={(payload) => this.onSaveClicked(payload)}>
        <Grid className="update-security-questions wrapper">
            <Row>
              <Col lg={12}>
                <PageTitle>Update security questions</PageTitle>
              </Col>
              <Col lg={12} className="description">
                <InlineCKEditor
                  identifier={`${PAGE_SLUG_UPDATE_SECURITY_QUESTION}_content_text`}
                  onContentSaved={this.handleContentSaved}
                  contents={this.props.contents[`${PAGE_SLUG_UPDATE_SECURITY_QUESTION}_content_text`]}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <RequiredPasswordMaskInput
                    model=".current_password"
                    label="Current Password"
                    controlId="currentPassword" />
                <SecurityQuestionAnswer
                    questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
                    questionModel=".security_answers_attributes[0].security_question_id"
                    answerModel=".security_answers_attributes[0].answer"
                    questionControlId="userSecurityQuestion1"
                    answerControlId="userSecurityAnswer1" />
                <SecurityQuestionAnswer
                    questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
                    questionModel=".security_answers_attributes[1].security_question_id"
                    answerModel=".security_answers_attributes[1].answer"
                    questionLabel="Security question 2"
                    answerLabel="Security answer 2"
                    answerPlaceHolder="Security answer 2"
                    questionControlId="userSecurityQuestion2"
                    answerControlId="userSecurityAnswer2" />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <ArrowButton color="red"
                    className="pull-right"
                    arrow={false}>
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Grid>
        </Form>
    );
    }
}

const mapStateToProps = (state) => {
  return {
    questions: state.aboutYou.questions,
    user: state.viewConfig.profile,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(UpdateSecurityQuestions);



// WEBPACK FOOTER //
// ./src/components/update-security-questions/index.jsx